<div class="parser-flows">
  <lib-pdf-ai-parser-nav></lib-pdf-ai-parser-nav>
  <lib-gung-flow-details></lib-gung-flow-details>
</div>
